export interface SupplementalLoanEligibility {
  canHaveSupplementalLoan: boolean
  ongoingApplicationReferenceNumber: number | null
  refusalReasonCodes: string[]
}

/** Keys under the `continueFinancing` translation namespace. */
export type ContinueFinancingDisableReason =
  | 'maximumAvalaibleAmountIsTooLow'
  | 'expiresOnIsPassed'
  | 'refinancingInProgress'
  | 'missingWorksheet'
  | 'documentsAreScanning'

/**
 * Maps the backend SupplementalLoanRefusalReasonEnum onto those keys. Codes absent from this
 * map are dropped rather than shown raw.
 */
const refusalReasonTranslationKeys: Record<string, ContinueFinancingDisableReason> = {
  UnderMinimalAmount: 'maximumAvalaibleAmountIsTooLow',
  CreditRepportExpired: 'expiresOnIsPassed',
  OnGoingCreditApplication: 'refinancingInProgress',
  MissingWorksheet: 'missingWorksheet',
  DocumentsAreScanning: 'documentsAreScanning',
}

export const toContinueFinancingTranslationKeys = (
  refusalReasonCodes: string[],
): ContinueFinancingDisableReason[] =>
  refusalReasonCodes
    .map((code) => refusalReasonTranslationKeys[code])
    .filter((key): key is ContinueFinancingDisableReason => !!key)
